
export default {
    setEstadoCivil(state, data) {
        state.estadoCivil = data
    },
    setEstadosCivies(state, data) {
        state.estadosCivies = data
    }
}